// src/providers/PedidoProviders.js
import React from 'react';
import { PedidoProvider } from '../contexts/pedidos/PedidoContext';
import { PedidoItemProvider } from '../contexts/pedidos/PedidoItemContext';
import { TaxaEntregaProvider } from '../contexts/pedidos/TaxaEntregaContext';
import { TaxaEntregaBairroProvider } from '../contexts/pedidos/TaxaEntregaBairroContext';
import { ConfigPedidoProvider } from '../contexts/pedidos/ConfigPedidoContext';
import { TiposEntregaProvider } from '../contexts/pedidos/TiposEntregaContext';
import { ChatBotWhatsappProvider } from '../contexts/pedidos/ChatBotWhatsappContext';
import { PedidoItemConjuntoProvider } from '../contexts/pedidos/PedidoItemConjuntoContext';
import { StoreStatusProvider } from '../contexts/pedidos/StoreStatusContext';
import { HorarioExcecaoProvider } from '../contexts/pedidos/HorarioExcecaoContext';
import { HorarioProvider } from '../contexts/pedidos/HorarioContext';

export default function PedidoProviders({ children }) {
  return (
    <ConfigPedidoProvider>
      <PedidoProvider>
        <PedidoItemProvider>
          <PedidoItemConjuntoProvider>
            <TaxaEntregaProvider>
              <TaxaEntregaBairroProvider>
                <TiposEntregaProvider>
                <ChatBotWhatsappProvider>
                  <StoreStatusProvider>
                    <HorarioExcecaoProvider>
                      <HorarioProvider>
                        {children}
                      </HorarioProvider>
                    </HorarioExcecaoProvider>
                  </StoreStatusProvider>
                </ChatBotWhatsappProvider>
                </TiposEntregaProvider>
              </TaxaEntregaBairroProvider>
            </TaxaEntregaProvider>
          </PedidoItemConjuntoProvider>
        </PedidoItemProvider>
      </PedidoProvider>
    </ConfigPedidoProvider>
  );
}
